import React from "react"
import PropTypes from "prop-types"
import TreatmentPage, {
  TreatmentPageProps,
} from "components/sections/treatment"
import LeadershipStaffMembers, {
  LeadershipStaffMembersProps,
} from "components/sections/leadership"
import ClinicTeam from "components/blocks/clinicTeam"
import PressCardsV2 from "components/sections/pressCardsV2"
import { FeaturedStaffCards } from "components/sections/staffCardsV2"

const OrderedList = ({
  displayStyle,
  excludeIds = [],
  headlineOrdered,
  items,
  title,
  type,
}) => {
  const intro = headlineOrdered?.headlineOrdered
  const linked = (items || []).filter(Boolean)

  // Display styles added for the About page. Without one, a list keeps its
  // original look.
  switch (displayStyle) {
    case "Featured Cards":
      return <FeaturedStaffCards intro={intro} members={linked} title={title} />

    // The same team cards and bio pop-up as the locations pages.
    case "Card Grid":
      return (
        <ClinicTeam
          collapseOnMobile
          doctors={linked.filter(item => !excludeIds.includes(item.id))}
          id="leadership"
          intro={intro}
          moreLabel="See full leadership team"
          title={title}
        />
      )

    case "Press Cards":
      return (
        <PressCardsV2 itemIds={linked.map(item => item.id)} title={title} />
      )

    default:
      break
  }

  switch (type) {
    case "Treatments":
      return (
        <TreatmentPage
          headline={
            headlineOrdered?.headlineOrdered
              ? headlineOrdered.headlineOrdered
              : title
              ? title
              : null
          }
          treatments={items}
        />
      )

    case "Staff Members":
      return <LeadershipStaffMembers members={items} />

    default:
      return null
  }
}

export const OrderedListProps = {
  displayStyle: PropTypes.string,
  excludeIds: PropTypes.arrayOf(PropTypes.string),
  headlineOrdered: PropTypes.shape({
    headlineOrdered: PropTypes.string,
  }),
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape(TreatmentPageProps),
      PropTypes.shape(LeadershipStaffMembersProps),
    ])
  ),
  title: PropTypes.string,
  type: PropTypes.string,
}

OrderedList.propTypes = OrderedListProps

export default OrderedList
